import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex w-full flex-col xl:h-screen"
}
const _hoisted_2 = { class: "flex flex-wrap overflow-scroll xl:flex-shrink-0p pb-s xl:flex-nowrap w-full justify-between items-center" }
const _hoisted_3 = { class: "flex items-center flex-1" }
const _hoisted_4 = { class: "flex w-full justify-end" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "block mx-1" }, null, -1)
const _hoisted_6 = { class: "flex flex-1 xl:overflow-scroll" }
const _hoisted_7 = {
  key: 0,
  class: "w-full xl:w-1/4 h-full xl:pl-m"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex items-center justify-center mt-xxl" }

import { computed, ref } from "vue";
import { supabase } from "@/helpers/supabase";
import RoundedCard from "@/components/RoundedCard.vue";
import { useRoute } from "vue-router";
import { onMounted } from "vue";
import router from "@/router";
import OrderChat from "../components/OrderChat.vue";
import OrderMessageBoxes from "../components/OrderMessageBoxes.vue";
import OrderMessageMedications from "../components/OrderMessageMedications.vue";
import { useSessionStore } from "@/store/sessionStore";
import { useOrdersStore } from "@/store/ordersStore";
import IconButton from "@/components/IconButton.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import LabelButton from "@/components/LabelButton.vue";
import UmanaHeadline from "@/components/UmanaHeadline.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersConversationView',
  setup(__props) {

const sessionStore = useSessionStore();
const ordersStore = useOrdersStore();
const route = useRoute();

const showChat = ref<boolean>(false);

const conversation = computed(
  () =>
    Array.from(ordersStore.conversations?.values() ?? []).find(
      (conversation) => conversation.id == parseInt(`${route.params.id}`)
    ) ?? null
);

const isSender = computed(
  () =>
    sessionStore.selectedCareProviderGroup?.id ==
    conversation.value?.senderCareProviderGroup.id
);

onMounted(() => {
  if (window.innerWidth >= 1280) {
    showChat.value = true;
  }
});

const isLoadingMedicationInformation = ref(true);
const errorLoadingMedicationInformation = ref(false);
if (conversation.value?.id) {
  ordersStore
    .fetchMedicationsInformation(conversation.value.id)
    .catch(() => {
      errorLoadingMedicationInformation.value = true;
    })
    .finally(() => {
      isLoadingMedicationInformation.value = false;
    });
} else {
  isLoadingMedicationInformation.value = false;
}

const messages = computed(() =>
  Array.from(ordersStore.messages?.values() ?? []).filter(
    (message) => message.conversation.id == conversation.value?.id
  )
);

function goBack() {
  if (window.history.state.back != null) {
    router.go(-1);
    return;
  }

  router.push({ name: "conversations" });
}

async function archive() {
  if (
    conversation.value != null &&
    sessionStore.selectedCareProviderGroup != null
  ) {
    await supabase.from("orders_conversation_status").upsert({
      conversation_id: conversation.value.id,
      care_provider_group_id: sessionStore.selectedCareProviderGroup.id,
      archived: true,
    });
    await ordersStore.updateConversations(conversation.value.id);
  }
}

async function unArchive() {
  if (
    conversation.value != null &&
    sessionStore.selectedCareProviderGroup != null
  ) {
    await supabase.from("orders_conversation_status").upsert({
      conversation_id: conversation.value.id,
      care_provider_group_id: sessionStore.selectedCareProviderGroup.id,
      archived: false,
    });
    await ordersStore.updateConversations(conversation.value.id);
  }
}

return (_ctx: any,_cache: any) => {
  return (conversation.value != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(LabelButton, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack())),
              icon: "left",
              label: "Eingang"
            }),
            _createVNode(UmanaHeadline, {
              h: "h1",
              class: "mx-xl flex-shrink-0"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(conversation.value?.decrypted_subject ?? ""), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            (conversation.value?.archived != true)
              ? (_openBlock(), _createBlock(IconButton, {
                  key: 0,
                  onClick: archive,
                  icon: "archive",
                  label: "Archivieren"
                }))
              : (_openBlock(), _createBlock(IconButton, {
                  key: 1,
                  onClick: unArchive,
                  icon: "left",
                  label: "In den Eingang verschieben"
                })),
            _hoisted_5,
            (conversation.value?.orders_sent != null)
              ? (_openBlock(), _createBlock(IconButton, {
                  key: 2,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showChat.value = !showChat.value)),
                  icon: "eye",
                  label: "Chat"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-full xl:w-3/4 overflow-scroll flex-1", { hidden: showChat.value, 'xl:block': true }])
          }, [
            (conversation.value?.orders_sent != null)
              ? (_openBlock(), _createBlock(RoundedCard, {
                  key: 0,
                  class: "p-4"
                }, {
                  default: _withCtx(() => [
                    (messages.value != null)
                      ? (_openBlock(), _createBlock(OrderMessageBoxes, {
                          key: 0,
                          messages: messages.value,
                          conversation: conversation.value,
                          "is-sender": isSender.value
                        }, null, 8, ["messages", "conversation", "is-sender"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (conversation.value != null)
              ? (_openBlock(), _createBlock(RoundedCard, {
                  key: 1,
                  class: "mt-m mb-s @container"
                }, {
                  default: _withCtx(() => [
                    (messages.value != null)
                      ? (_openBlock(), _createBlock(OrderMessageMedications, {
                          key: 0,
                          messages: messages.value,
                          conversation: conversation.value,
                          "is-sender": isSender.value,
                          "is-loading-medication-information": isLoadingMedicationInformation.value,
                          "error-loading-medication-information": 
              errorLoadingMedicationInformation.value
            
                        }, null, 8, ["messages", "conversation", "is-sender", "is-loading-medication-information", "error-loading-medication-information"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2),
          (showChat.value && conversation.value?.orders_sent != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (conversation.value != null)
                  ? (_openBlock(), _createBlock(OrderChat, {
                      key: 0,
                      messages: messages.value,
                      conversation: conversation.value
                    }, null, 8, ["messages", "conversation"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(LoadingSpinner)
        ]),
        _createElementVNode("a", {
          href: "#",
          class: "text-green hover:text-green-2 text-center block mt-s",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (goBack())),
          color: "orange"
        }, "Abbrechen")
      ]))
}
}

})